import React from "react";
import moment from "moment";
import ExpiredBadge from "../Contrato/ExpiredBadge";

const ContratoDataFim = ({
  dataFim,
  exibirTempoRestante = false,
  exibirBadge = false,
}) => {
  if (!dataFim) {
    return <i>Indeterminado</i>;
  }

  const today = moment().startOf("day");

  const a = moment(dataFim?.date);

  if (!exibirTempoRestante) {
    return <>{a.format("DD/MM/YYYY")}</>;
  }

  const diffDuration = moment.duration(a.diff(today));

  const anosRestantes = diffDuration.years();
  const mesesRestantes = diffDuration.months();
  const diasRestantes = diffDuration.days();

  if (exibirBadge && diasRestantes + mesesRestantes + anosRestantes < 1)
    return <ExpiredBadge />;

  return (
    <>
      {a.format("DD/MM/YYYY")}&nbsp;
      <span
        style={{
          color: "#666666",
          fontWeight: "400",
        }}
      >
        ({anosRestantes > 1 && anosRestantes + " anos, "}
        {anosRestantes === 1 && "1 ano, "}
        {mesesRestantes > 1 && mesesRestantes + " meses e "}
        {mesesRestantes === 1 && "1 mês e "}
        {diasRestantes > 1 && diasRestantes + " dias restantes"}
        {diasRestantes === 1 && "1 dia restante "})
      </span>
    </>
  );
};

export default ContratoDataFim;
